module.exports = __webpack_public_path__ + "static/background-mobile-a1ec8f640bcb31f65042ef75e1051105.jpg";